import { fromJson, type JsonObject } from "@bufbuild/protobuf";
import type { Field } from "#gen/forms/v1/field_pb.js";
import { FormSchema } from "#gen/forms/v1/forms_pb.js";
import type { Component, Page } from "#gen/pages/v2/page_pb.js";
import { objectValue, structValue } from "#lib/struct.js";

function collectFormIds(component: Component, ids: string[]) {
	if (component.typeUri.includes("Form")) {
		ids.push(component.id);
	}
	component.children.forEach(component => collectFormIds(component, ids));
}

function getFormIdsFromPage(page: Page): string[] {
	const forms: string[] = [];
	page.components.forEach(component => collectFormIds(component, forms));
	return forms;
}

export function getFormFieldsOnPage(page: Page, data: JsonObject): Record<string, Field[]> {
	const forms = getFormIdsFromPage(page);
	const fields = {} as Record<string, Field[]>;
	for (const id of forms) {
		const formConfig = structValue(data, id);
		const form = fromJson(FormSchema, objectValue(formConfig, "form") ?? {}, { ignoreUnknownFields: true });
		fields[id] ??= [];
		fields[id].push(...form.fields);
	}
	return fields;
}
